import { BLOCKS, INLINES, type Document as RichTextDocument } from '@contentful/rich-text-types'

export const faqData = [
  {
    question: `What is a first-party data collection platform?`,
    answer: {
      content: [
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `A first-party data collection platform is a tool that allows you to collect data from people who visit your website, use your products, or visit your physical locations. Governing how and where first-party data can be used is the key to `,
            },
            {
              content: [
                {
                  data: {},
                  marks: [],
                  nodeType: `text`,
                  value: `first-party data privacy`,
                },
              ],
              data: {
                uri: `https://segment.com/resources/data-privacy/why-first-party-data-key-to-data-privacy/`,
              },
              nodeType: INLINES.HYPERLINK,
            },
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `.`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    } as RichTextDocument,
  },
  {
    question: `What can you do with Segment’s first-party data collection platform?`,
    answer: {
      content: [
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `Segment helps collect, clean, and consolidate first-party data at scale and in real time. With unified
              profiles, businesses gain a 360-degree view of their customers to understand their behavior, preferences, and
              trends. This can be used to create highly nuanced audience segments and to orchestrate personalized
              experiences based on people’s real-time behavior.`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `Segment helps collect, clean, and consolidate first-party data at scale and in real time. With unified profiles, businesses gain a 360-degree view of their customers to understand their behavior, preferences, and trends. This can be used to create highly nuanced audience segments and to orchestrate personalized experiences based on people’s real-time behavior.
              With the ability to send this data to any downstream tool for activation, Segment drastically improves time-to-value. Technical teams save valuable time spent integrating new tools and pulling audiences lists, while marketers gain the ability to spin up data-driven campaigns autonomously.`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    } as RichTextDocument,
  },
  {
    question: `How does Segment collect first-party customer data?`,
    answer: {
      content: [
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `Segment uses a single API to collect customer event data and to enrich that data with information stored in a data warehouse,
              CRM, payment systems, internal databases, and more. You can connect your data Sources in-app, or programmatically with the `,
            },
            {
              content: [
                {
                  data: {},
                  marks: [],
                  nodeType: `text`,
                  value: `Segment API`,
                },
              ],
              data: {
                uri: `https://docs.segmentapis.com/`,
              },
              nodeType: INLINES.HYPERLINK,
            },
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `.`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    } as RichTextDocument,
  },
  {
    question: `What tools can Connections send first-party customer data to?`,
    answer: {
      content: [
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `Connections offers more than 450 pre-built integrations that include storage systems (e.g., Snowflake, BigQuery, Amazon S3,
                Redshift), business intelligence tools, and marketing automation tools. With Functions, teams can also create
                their own custom sources and destinations.`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    } as RichTextDocument,
  },
]
